// i18n-config.js

export const i18n = {
  defaultLocale: 'en',
  locales: ['da', 'de', 'en', 'es', 'fr', 'it', 'nl', 'no', 'sv'],  // 'pl', 'pt', 'ru'
  languageNames: {
    DA: 'Dansk',        // Danish
    DE: 'Deutsch',      // German
    EN: 'English',
    ES: 'Español',
    FR: 'Français',
    IT: 'Italiano',
    NL: 'Nederlands',   // Dutch (Netherlands)
    NO: 'Norsk',        // Norwegian
    PL: 'Polski',       // Polish
    PT: 'Português',    // Portuguese
    RU: 'Русский',      // Russian
    SV: 'Svenska',      // Swedish
  }
};
